/* Reusable "Export CSV" button. Calls the export endpoint with the current
 * JWT, gets a blob, triggers a browser download via an object URL. */
import { useState } from "react";
import { Download, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { Button } from "../components/ui/button";

const BACKEND = process.env.REACT_APP_BACKEND_URL;

function buildUrl(endpoint, params) {
  const u = new URL(`${BACKEND}${endpoint}`);
  Object.entries(params || {}).forEach(([k, v]) => {
    if (v === undefined || v === null || v === "") return;
    if (typeof v === "boolean") u.searchParams.set(k, String(v));
    else u.searchParams.set(k, v);
  });
  return u.toString();
}

export default function ExportCsvButton({
  endpoint,
  params,
  filename = "export",
  label = "Export CSV",
  testid = "export-csv-btn",
}) {
  const [loading, setLoading] = useState(false);
  const onClick = async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem("medibook_token") || "";
      const res = await fetch(buildUrl(endpoint, params), {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (!res.ok) {
        let detail = "";
        try { detail = (await res.json()).detail || ""; } catch { /* ignore */ }
        throw new Error(detail || `HTTP ${res.status}`);
      }
      const blob = await res.blob();
      // pull filename from Content-Disposition when present
      let dl = `medibook_${filename}.csv`;
      const cd = res.headers.get("Content-Disposition") || "";
      const match = cd.match(/filename="([^"]+)"/i);
      if (match) dl = match[1];
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url; a.download = dl;
      document.body.appendChild(a); a.click(); a.remove();
      URL.revokeObjectURL(url);
      toast.success("Export downloaded");
    } catch (e) {
      toast.error(`Export failed — ${e.message || e}`);
    } finally { setLoading(false); }
  };
  return (
    <Button
      type="button" variant="outline" onClick={onClick} disabled={loading}
      data-testid={testid}
      className="bg-transparent border-mb-border hover:bg-mb-surface2 text-zinc-200 inline-flex items-center gap-2 h-9"
    >
      {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : <Download className="h-4 w-4" />}
      {label}
    </Button>
  );
}
